// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f4-a";
export var fulfillmentFormRail = "_f4-9";
export var headerTitleRow = "_f4-c";
export var orderDetailsWrapper = "_f4-7";
export var orderLinkTrigger = "_f4-2";
export var paymentInformationGrid = "_f4-h";
export var paymentSummaryColumn = "_f4-i";
export var shipmentContainer = "_f4-b";
export var shipmentDetailsMainPane = "_f4-8";
export var shipmentNavigationCard = "_f4-5";
export var shipmentNavigationRail = "_f4-3";
export var shipmentNavigationRailHeader = "_f4-4";
export var shipmentSummaryFact = "_f4-e";
export var shipmentSummaryGrid = "_f4-d";
export var shipmentSummaryMetadataRow = "_f4-f";
export var shipmentSummaryTags = "_f4-g";
export var shipmentWorkspace = "_f4-0";
export var shipmentWorkspaceContent = "_f4-6";
export var shipmentWorkspaceHeader = "_f4-1";